import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';

const AddItemCat = ({ show, onClose, onCreated ,refresh ,onSuccess }) => { 
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [generalError, setGeneralError] = useState(''); 
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');

  

 const handleNameChange = (e) => {
    let value = e.target.value;

    // Remove numbers and special characters, allow only letters and spaces
    value = value.replace(/[^A-Za-z\s]/g, '');

    // Convert to Title Case
    value = value
        .split(' ')
        .map(word =>
            word.length > 1
                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word.toUpperCase()
        )
        .join(' ');

    setName(value);
    setErrors(prev => ({ ...prev, itemcategory_name: '' }));
    setGeneralError('');

    if (value.length <= 25) {
        setNameLengthError('');
    }
};

 

const handleDescriptionChange = (e) => {
    let value = e.target.value;

    // Remove only semicolons
    value = value.replace(/;/g, '');

    // Convert to Title Case (optional for description; can be removed if free text is better)
    value = value
        .split(' ')
        .map(word =>
            word.length > 1
                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word.toUpperCase()
        )
        .join(' ');

    setDescription(value);

    if (value.length > 100) {
        setDescLengthError('Item Category (max 100 characters)');
    } else {
        setDescLengthError('');
    }
};


    const handleSubmit = () => {
        setErrors({});
        setGeneralError('');
        setNameLengthError('');
        setDescLengthError('');

        if (!name) {
            setErrors(prev => ({
                ...prev,
                itemcategory_name: "This Field is Required"
            }));
            return;
        }

        if (name.length > 25) {
            setNameLengthError('Item Category (max 25 characters)');
            return;
        }

        if (description.length > 100) {
            setDescLengthError('Description (max 100 characters)');
            return;
        } 

        axios.post(`${baseURL}/item-categories`, {
            itemcategory_name: name,
            description: description,
        })
        .then(() => {
            onClose();
            if (onCreated) onCreated();
            if (onSuccess) onSuccess();
            // window.location.reload();
        })
        .catch(error => {
            const res = error.response;
            console.log("Error response:", res?.data);

            // Handle specific message
            if (res?.data?.message) {
                setGeneralError(res.data.message); // <-- Set the general error
            }

            // Optional: Fallback for validation structure
            if (res?.data?.errors) {
                setErrors(res.data.errors);
            }
        });
    };

    return (
        // <Modal show={show} size="md">
        <Modal show={show} size="md" backdrop="static" keyboard={false}> 
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Item Category</h3>
                    <Button variant="" className="close px-6 py-2" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>  
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Item Category <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Item Category"
                                value={name}
                                maxLength={25}
                                onChange={handleNameChange}
                            />
                            {errors.itemcategory_name && (
                                <div className="text-danger mt-1">{errors.itemcategory_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger mt-1">{nameLengthError}</span>
                            )}
                            {generalError && (
                                <span className="text-danger mt-1">{generalError}</span>
                            )}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                maxLength={100}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger mt-1">{descLengthError}</span>
                            )}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
                        <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
                        <Button variant="primary" size="sm" onClick={handleSubmit}>Create Item Category</Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddItemCat;
